import React from 'react'
import { CardImg, Col, Row } from 'reactstrap'
import PersonalDiagram from '../../../images/personal_diagram.jpg'

const Personal = () => {
  return (
    <div className="increase-p-font1-5">
      <h1>Personal Edition</h1>
      <Row>
        <Col md={6}>
          <div>
            <p>Whether you&#39;re running a Sole Proprietorship or whether you&#39;re simply trying to
              manage your life, Prioritize.Plus can help you keep your daily activities focused on your long term
              priorities.
            </p>
            <div>
              <h2>How It Works</h2>
              <ul>
                <li><p>First, identify your core priorities.</p></li>
                <li><p>Second, create one or more strategies to fulfill each priority.</p></li>
                <li><p>Third, set goals for working each strategy.</p></li>
                <li><p>Then, you simply record progress toward your goals as journal entries.</p></li>
              </ul>
              <p>Over time, you&#39;ll be able to list your accomplishments for each priority
                or strategy to see where you&#39;re spending your time and energy.
              </p>
            </div>
          </div>
        </Col>
        <Col md={6}>
          <CardImg src={PersonalDiagram} className="img-responsive padding10" />
        </Col>
      </Row>
    </div>
  )
}

export default Personal
